import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const cache = {};

export const useContent = (path, fallback = null) => {
  const [data, setData] = useState(cache[path] ?? fallback);
  useEffect(() => {
    let alive = true;
    api.get(path).then((r) => { cache[path] = r.data; if (alive) setData(r.data); }).catch(() => { if (alive) setData((d) => d ?? null); });
    return () => { alive = false; };
  }, [path]);
  return data;
};

export const clearContentCache = () => Object.keys(cache).forEach((k) => delete cache[k]);

export const RichText = ({ text, className = "", testid }) => (
  <div className={`space-y-4 leading-relaxed ${className}`} data-testid={testid}>
    {(text || "").split(/\n\s*\n/).map((para, i) => (
      <p key={i} className="whitespace-pre-line">{para.trim()}</p>
    ))}
  </div>
);

export const HOME_DEFAULT = {
  hero_text: "Prodotti sigillati, carte singole collezionabili e accessori per Magic, Pokémon, One Piece, Yu-Gi-Oh!, Riftbound, Lorcana e Dragon Ball Super.",
  hero_image: null, cta1_label: "Esplora il catalogo", cta1_link: "/catalogo", cta2_label: "Prodotti sigillati", cta2_link: "/catalogo?category=sigillati",
  featured_eyebrow: "In vetrina", featured_title: "Pezzi da collezione", latest_eyebrow: "Appena arrivati", latest_title: "Nuovi arrivi",
  contact_title: "Hai una domanda o sei un negozio?", contact_text: "Scrivici per info, assistenza sugli ordini o forniture all'ingrosso B2B.",
};

export const SmartLink = ({ to, children, ...props }) => (to?.startsWith("https://") ? <a href={to} target="_blank" rel="noreferrer" {...props}>{children}</a> : <Link to={to || "/"} {...props}>{children}</Link>);

export const fmtDay = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" }) : "");
